import { SsoData } from "../models/login.models";

export class LoginUtility {

    public static async getSsoDataFromSsoPageUrl(pageUrl: string): Promise<SsoData> {
        let response = await jQuery.get(pageUrl);
        let jResponse = jQuery(response);
        
        let refreshToken = jResponse.find("input[name=refresh_token]").val().toString();
        let redirectUrl = jResponse.attr("action");
        return {
            redirectUrl,
            refreshToken,
            fullResponseString: response
        };
    }

}